import React, { Component } from "react";

import Checkbox from "Components/checkbox/Checkbox";

import t from "Utils/translation";
import s from "./resourceSelector.scss";
import cx from "classnames";
import Toggle from "Components/toggle/Toggle";

class ResourcesSelector extends Component {
  constructor(props) {
    super(props);
    this.checkElement = this.checkElement.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.state = {
      selectAll: this.props.allSelected,
    };
  }

  toggleAll(elem) {
    // this.setState({ selectAll: e.target.checked });

    this.setState(elem);
    this.props.onSelectAllToggle && this.props.onSelectAllToggle(elem);
    let checkeds = {};
    this.props.resources.forEach((res) => {
      if (!res.disabled) {
        checkeds[res.value] = elem.selectAll;
      }
    });
    this.props.onChange({ [this.props.name]: checkeds });
  }

  checkElement(e) {
    const checkeds = this.props.checkeds || {};
    this.props.onChange({
      [this.props.name]: Object.assign({}, checkeds, e),
    });

    this.setState({ selectAll: false });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.resources || nextProps.resources.length === 0) {
      this.setState({ selectAll: false });
    }
  }

  render() {
    const {
      className,
      resources,
      checkeds = {},
      disabledMsg,
      selectAllAsToggle = false,
      selectAllLabel = null,
      groupLabel = null,
    } = this.props;

    if (
      this.props.allSelected !== null &&
      this.props.allSelected !== undefined &&
      this.props.allSelected !== this.state.selectAll
    ) {
      this.setState({ selectAll: this.props.allSelected });
    }

    return (
      <div className={cx(className, s.resourcesSelector)}>
        {selectAllAsToggle ? (
          <Toggle
            name="selectAll"
            label={selectAllLabel ? selectAllLabel : t("input.label.selectAll")}
            checked={this.state.selectAll}
            onChange={this.toggleAll}
          />
        ) : (
          <Checkbox
            label={selectAllLabel ? selectAllLabel : t("input.label.selectAll")}
            name="selectAll"
            checked={this.state.selectAll}
            onChange={this.toggleAll}
          />
        )}

        <div className={s.wrapSelectionBox}>
          <div className={s.labelSelectionBox}>{groupLabel ? groupLabel : t("input.label.selectMboxes")}</div>
          <div className={s.selectionBox}>
            {resources.map((res) => (
              <div key={res.value}>
                <Checkbox
                  className={cx({ [s.disabledCheckbox]: res.disabled })}
                  label={res.label}
                  name={res.value}
                  value={res.value}
                  disabled={res.disabled}
                  checked={!!checkeds[res.value]}
                  onChange={this.checkElement}
                />
              </div>
            ))}
          </div>
        </div>

        {disabledMsg && <div className={s.disabledMsg}>{disabledMsg}</div>}
      </div>
    );
  }
}

export default ResourcesSelector;
